import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { FormulaRegionTileFragment } from "../../client/generated";
import { assertTypeName } from "../../client/guards";
import { RegionTile } from "../../regions/RegionTile";

type Props = {
  fragment: FormulaRegionTileFragment;
  expressionAttributeId: string;
  children: React.ReactNode;
  dispatch: Dispatch<EditorAction>;
};

export function FormulaRegionTile({
  fragment,
  expressionAttributeId,
  children,
  dispatch,
}: Props) {
  const expressionAttribute = fragment.attributes.find(
    (a) => a.id === expressionAttributeId,
  );
  assertTypeName(expressionAttribute?.__typename === "ExpressionAttribute");

  const onClick = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "update",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTile
      fragment={fragment}
      preview={expressionAttribute.expressionLatex}
      onClick={onClick}
    >
      {children}
    </RegionTile>
  );
}
